import { useMemo } from 'react';
import { isValidWaitingRoomSession } from '../../filters/scheduleFilters';
import { useSelectedSessions } from './useSelectedSessions';
import { useEventSchedule } from './useEventSchedule';


export function useIsValidWaitingRoomSessionFilter(eventId) {
    const all = useEventSchedule(eventId), selectedSessions = useSelectedSessions(eventId);
    return useMemo(
        () => (session) => isValidWaitingRoomSession(session, selectedSessions, all),
        [selectedSessions, all]
    );
}
